<template>
  <v-dialog
    v-model="isInfoDialogOpen"
    max-width="650px"
    @click:outside="$emit('update:is-info-dialog-open',false)"
  >
    <v-card class="pa-sm-10 pa-3">
      <v-card-title class="justify-center text-h5">
        Editar informações de Perfil
      </v-card-title>

      <v-card-text class="mt-5">
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="update"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
            >
              <v-text-field
                v-model="perfilDataLocale.nome"
                outlined
                dense
                label="Nome"
                :rules="[validators.required, (v) => (!!v && v.length <= 100) || 'Máximo de 100 caracteres']"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="12"
            >
              <v-textarea
                v-model="perfilDataLocale.descricao"
                outlined
                dense
                label="Descrição"
                :rules="[validators.required, (v) => (!!v && v.length <= 255) || 'Máximo de 255 caracteres']"
                auto-grow
              ></v-textarea>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
            </v-col>

            <v-col
              cols="12"
              class="d-flex justify-end "
            >
              <v-btn
                outlined
                class="me-3"
                color="secondary"
                @click="$emit('update:is-info-dialog-open',false)"
                @click.prevent="resetForm"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                type="submit"
              >
                Salvar alterações
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import PerfilService from '@/services/modules/PerfilService'

export default {
  props: {
    isInfoDialogOpen: {
      type: Boolean,
      required: true,
    },
    perfilData: {
      type: Object,
      default: () => {},
    },
  },

  setup(props, { emit }) {
    const perfilDataLocale = ref(props.perfilData)

    const resetForm = () => {
      perfilDataLocale.value = JSON.parse(JSON.stringify(props.perfilData))
    }

    watch(
      () => props.isInfoDialogOpen,
      () => {
        perfilDataLocale.value = JSON.parse(JSON.stringify(props.perfilData))
      },
    )

    const loading = ref(false)
    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    const update = () => {
      loading.value = !loading.value

      const perfilId = perfilDataLocale.value.id

      if (valid.value) {
        PerfilService.update(perfilId, perfilDataLocale.value)
          .then(() => {
            loading.value = !loading.value
            emit('refresh-data')
            emit('update:is-info-dialog-open', false)
          })
          .catch(() => {
            loading.value = !loading.value
          })
      } else {
        loading.value = !loading.value
        validate()
      }
    }

    return {
      perfilDataLocale,
      resetForm,
      update,
      form,
      valid,
      validate,
      loading,
      validators: {
        required,
      },
    }
  },
}
</script>
